export const LABELS = {
	DASHBOARD: {
		ACCESSIBILITY_DASHBOARD_DESCRIPTION:
			'This dashboard shows aggregated data from the Web Flow Analyzer and Web SDKs only.',
		ACCESSIBILITY_DASHBOARD_TABS: {
			DASHBOARD: 'Dashboard',
			ISSUES: 'Issues',
			BUSINESS_UNITS: 'Business Units'
		}
	}
};
